import React, { useEffect, useState } from "react";
import { Form, FormControl, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./AddofferPage.css";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { check } from "../../comman/components/CommonimagePath";
import { postRequestcall } from "../../comman/util/postRequest";
import { ADD_OFFER, SEND_NOTIFICATION } from "../../constants/apiurl";
import FormgroupPage, { FormLabel } from "../../comman/formgroup/FormgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { fetchLogindata } from "../../login/redux/actions";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

function AddofferPage(props) {
  const { t } = useTranslation();
  const { access_token } = props;
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const nameRegex = /^[A-Za-z 0-9]+$/;
  const [addoffer, setAddoffer] = useState({
    title: "",
    title_in_tr: "",
    offertype: {
      label: "",
      value: "",
    },
    percentage: "",
    product: {
      label: "",
      value: "",
    },
    start_date: "",
    end_date: "",
    for_online_payment: true,
    voucherState: true,
    min_order_amount: "",
    coupon_code: "",
    type: "percentage",
    description: "",
    description_in_tr: "",
    active_status: true,
  });
  const [errors, setErrors] = useState({
    title: "",
    title_in_tr: "",
    offertype: "",
    percentage: "",
    start_date: "",
    end_date: "",
    for_online_payment: "",
    voucherState: "",
    coupon_code: "",
    min_order_amount: "",
    type: "",
    description: "",
    description_in_tr: "",
    active_status: "",
  });
  let { state } = useLocation();
  let navigate = useNavigate();
  const [FormState, setFormState] = useState("add");
  const colorList = [
    { color: "#538DD1" },
    { color: "#53C175" },
    { color: "#F56BC5" },
    { color: "#935656" },
    { color: "#EB9658" },
  ];
  const [color, setColor] = useState(colorList[0].color);

  useEffect(() => {
    checkFormState(state);
    // eslint-disable-next-line
  }, [!state, props?.language]);

  const checkFormState = (item1) => {
    props?.fetchHeaderContent(t("pages.sidenav.addoffer"), "", "");
    if (item1 === null) {
      setFormState("add");
    } else {
    setFormState("edit");
      const item = item1.item;
      console.log("item", item)
    setAddoffer({
        title: item?.title,
        title_in_tr: item?.title_in_tr,
        offertype: {
          label: "",
          value: "",
        },
        percentage: item?.percentage ? parseFloat(item?.percentage) : parseFloat(item?.flat_discount),
        applies: {
          label: "",
          value: "",
        },
        product: {
          label: "",
          value: "",
        },
        start_date: item?.start_date,
        end_date: item?.end_date,
        for_online_payment: item?.for_online_payment === "yes" ? true : false,
        voucherState: item.coupon_code ? true : false,
        min_order_amount: item?.min_order_amount,
        coupon_code: item?.coupon_code,
        type: item?.type,
        description: item?.description,
        description_in_tr: item?.description_in_tr,
        active_status: item?.active_status === "active"?true:false,
      });
      setColor(`#${item.color}`);
    }
  };

  const validation = () => {
    let value = true;
    if (addoffer.offertype.value === "") {
      value = true;
    }
    if (addoffer.product.value === "") {
      value = true;
    }
    if (addoffer.percentage === "") {
      errors.percentage = "pages.add_offer.enterdiscount";
      value = false;
    }
    if (addoffer.type === "") {
      errors.type = "pages.add_offer.discounttype_warn";
      value = false;
    }
    if (addoffer.title === "" && addoffer.title_in_tr === "") {
      if (props?.language === "Tr") {
        errors.title_in_tr = "pages.add_offer.title_warn";
      } else {
        errors.title = "pages.add_offer.title_warn";
      }
      value = false;
    }
    if (addoffer.description === "" && addoffer.description_in_tr === "") {
      if (props?.language === "Tr") {
        errors.description_in_tr = "pages.add_offer.description_place";
      } else {
        errors.description = "pages.add_offer.description_place";
      }
      value = false;
    }

    if (addoffer.start_date === "") {
      errors.start_date = "pages.add_offer.startdate_warn";
      value = false;
    }
    if (addoffer.end_date === "") {
      errors.end_date = "pages.add_offer.enddate_warn";
      value = false;
    }
    if (addoffer.min_order_amount === "") {
      errors.min_order_amount = "pages.add_offer.minimum_warn";
      value = false;
    }
    if (addoffer.voucherState === true) {
      if (!nameRegex.test(addoffer.coupon_code)) {
        errors.coupon_code = "pages.add_offer.allowcharacters";
        value = false;
      }
      if (addoffer.coupon_code === "") {
        errors.coupon_code = "pages.add_offer.code_warn";
        value = false;
      }
    }
    setErrors({
      ...errors,
      title: errors.title,
      title_in_tr: errors.title_in_tr,
      description: errors.description,
      description_in_tr: errors.description_in_tr,
      offertype: errors.offertype,
      percentage: errors.percentage,
      product: errors.product,
      applies: errors.applies,
      start_date: errors.start_date,
      end_date: errors.end_date,
      coupon_code: errors.coupon_code,
      min_order_amount: errors.min_order_amount,
      type: errors.type,
    });
    return value;
  };
  // useEffect(()=>{
  //   if(addoffer.type){
  //     setAddoffer((addoffer)=>({
  //       ...addoffer,
  //       percentage: "",
  //     }));
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[addoffer.type])
  const InputChange = (e) => {
    let value = e.target.value;
    if(e.target.name === 'percentage' && addoffer.type === "percentage"){
      if((e.target.value >= 0 && e.target.value <= 100) || e.target.value === ""){
        value = e.target.value
      }else{
        value = addoffer?.percentage
      }
    } else if(e.target.name === 'percentage' && addoffer.type !== "percentage"){
      if((e.target.value >= 0 && e.target.value <= 10000) || e.target.value === ""){
        value = e.target.value
      }else{
        value = addoffer?.percentage
      }
    }
    setAddoffer((addoffer)=>({
      ...addoffer,
      [e.target.name]: value,
    }));
    switch (e.target.name) {
      case "description_in_tr":
        setErrors({
          ...errors,
          description: "",
          description_in_tr: "",
        });
        break;
      case "description":
        setErrors({
          ...errors,
          description: "",
          description_in_tr: "",
        });
        break;
      case "title":
        setErrors({
          ...errors,
          title: "",
          title_in_tr: "",
        });
        break;
      case "title_in_tr":
        setErrors({
          ...errors,
          title: "",
          title_in_tr: "",
        });
        break;
      default:
        setErrors({
          ...errors,
          [e.target.name]: "",
        });
        break;
    }
  };
  const InputCheck = (e) => {
    setAddoffer((addoffer)=>({
      ...addoffer,
      [e.target.name]: e.target.checked,
    }));
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };
  const discountOnchange = (e) => {
    switch (e.target.id) {
      case "addoffer_per_discount":
        setAddoffer({
          ...addoffer,
          type: "percentage",
          percentage: "",
        });
        break;
      case "addoffer_flat_discount":
        setAddoffer({
          ...addoffer,
          type: "flat",
          percentage: "",
        });
        break;
      default:
        break;
    }
    setErrors({
      ...errors,
      type: "",
    });
  };

  const callAddOffers = async (e) => {
    e.preventDefault();
    if (validation()) {
      let payload = {
        color: color.substring(1),
        percentage: addoffer?.type === "percentage" ? addoffer?.percentage : "",
        flat_discount: addoffer?.type === "flat" ? addoffer?.percentage : "",
        for_online_payment: addoffer?.for_online_payment ? "yes" : "no",
        min_order_amount: addoffer?.min_order_amount,
        end_date: moment(addoffer?.end_date).format("YYYY-MM-DD"),
        start_date: moment(addoffer?.start_date).format("YYYY-MM-DD"),
        title: addoffer?.title === "" ? addoffer?.title_in_tr : addoffer?.title,
        title_in_tr:
          addoffer?.title_in_tr !== ""
            ? addoffer?.title_in_tr
            : addoffer?.title,
        description:
          addoffer?.description === ""
            ? addoffer?.description_in_tr
            : addoffer?.description,
        description_in_tr:
          addoffer?.description_in_tr !== ""
            ? addoffer?.description_in_tr
            : addoffer?.description,
        type: addoffer?.type,
        store_id: props?.storeDetail?.store_id,
        coupon_code: addoffer?.coupon_code,
        active_status: addoffer?.active_status ? "active" : "deactive",
        id: FormState === "add" ? "" : state?.item?.oid,
      };
      const URL = `${ADD_OFFER}?lang=${props.language.toLowerCase()}`
      let responceAddOfer = await postRequestcall(
        URL,
        access_token,
        payload
      );
      if (responceAddOfer?.status === 200) {
        let updateres = await responceAddOfer.json();
        if(payload?.id){
          toast.success(t("pages.Offer updated successfully"));
        }else{
          toast.success(t("pages.add_offer.add_toast"));
        }
          setAddoffer({
            title: "",
            title_in_tr: "",
            offertype: {
              label: "",
              value: "",
            },
            percentage: "",
            product: {
              label: "",
              value: "",
            },
            start_date: "",
            end_date: "",
            for_online_payment: true,
            voucherState: true,
            min_order_amount: "",
            coupon_code: "",
            type: "",
            description_in_tr: "",
            active_status: true,
          });
          navigate("/vendor/offers");
          let geturl = SEND_NOTIFICATION + `?type=${"offer"}&id=${updateres?.data?.id}`
          await postRequestcall(geturl,access_token,"");
      }
      else if(responceAddOfer?.status === 400) {
        let getError = await responceAddOfer.json()
        toast.error(getError?.errors)
        console.log("responceAddOfer", responceAddOfer)
      }else if(responceAddOfer?.status === 403) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindatas);
        let getError = await responceAddOfer.json();
        toast.error(getError?.errors);
        navigate("/vendor/");
      }
    }
  };

  const GenerateCode = (length) => {
    let result = " ";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    setErrors({ ...errors, coupon_code: "" });
    return result.toUpperCase();
  };
  const CancelForm = (e) => {
    e.preventDefault();
    navigate("../");
  };
  function LightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    var b = ((num >> 8) & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    var g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
  }

  const DateChange = (e) => {
    console.log("e.value", e.value)
    switch (e.name) {
      case "end_date":
        if (addoffer?.start_date === "") {
          setAddoffer({
            ...addoffer,
            end_date: e.value,
            start_date: e.value,
          });
        } else {
          const start = Date.parse(addoffer?.start_date);
          const end = Date.parse(e.value);
          if (start <= end) {
            setAddoffer({
              ...addoffer,
              end_date: e.value,
            });
          } else {
            setAddoffer({
              ...addoffer,
              end_date: e.value,
              start_date: e.value,
            });
          }
        }
        break;
      case "start_date":
        if (addoffer?.end_date === "") {
          setAddoffer({
            ...addoffer,
            end_date: e.value,
            start_date: e.value,
          });
        } else {
          const start = Date.parse(addoffer?.start_date);
          const end = Date.parse(e.value);
          if (start >= end) {
            setAddoffer({
              ...addoffer,
              start_date: e.value,
            });
          } else {
            setAddoffer({
              ...addoffer,
              end_date: e.value,
              start_date: e.value,
            });
          }
        }
        break;
      default:
        break;
    }
    setErrors({
      ...errors,
      [e.name]: "",
    });
  };

  return (
    <div className="col-xl-9 mb-3 main-content addoffer-centent">
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-center justify-content-between align-items-start">
            <h5 className="header-title mb-3">{t("pages.add_offer.title")}</h5>
            <label
              onClick={() => navigate("../")}
              className="go-back primary-text"
            >
              {t("pages.add_offer.goto_offer")}
            </label>
          </div>
          <Form onSubmit={callAddOffers}>
            <Row>
              <div className="ticket_top">
                <div className="mb-3  col-md-6 col-lg-6 col-xl-6 title-row">
                  <div className="mb-3 mt-3  col-md-12 col-lg-12 col-xl-12 color_row offertype-row">
                    <div className="d-flex align-center align-items-start">
                      <FormLabel 
                        label= {t("pages.add_offer.color")}
                        require={false}
                      />
                      <div className="colors_div">
                        {colorList.map((item, index) =>
                          color === item?.color ? (
                            <div
                              className="color_selection m-2 transition"
                              key={index.toString()}
                              style={{ backgroundColor: item?.color }}
                            >
                              <img src={check} alt="check"></img>
                            </div>
                          ) : (
                            <div
                              className="color_selection m-2 transition"
                              onClick={() => setColor(item?.color)}
                              key={index.toString()}
                              style={{ backgroundColor: item?.color }}
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 mt-3  col-md-12 col-lg-12 col-xl-12 type-row">
                    <div className="d-flex align-center align-items-start">
                      <Form.Check
                        id={"addoffer_per_discount"}
                        className={"me-5"}
                        type={"radio"}
                        name={"type"}
                        onChange={discountOnchange}
                        checked={addoffer.type === "percentage" ? true : false}
                        label={t("pages.add_offer.persent")}
                      />
                      <Form.Check
                        id={"addoffer_flat_discount"}
                        type={"radio"}
                        name={"type"}
                        onChange={discountOnchange}
                        checked={addoffer.type === "flat" ? true : false}
                        label={t("pages.add_offer.flat")}
                      />
                    </div>
                    <span className="warning text-danger">
                      {t(errors.type)}
                    </span>
                  </div>
                  <div className="mb-3  col-md-12 col-lg-12 col-xl-12 percentage-row ">
                    <FormgroupPage 
                      label={(addoffer.type === "percentage"
                        ? t("pages.add_offer.select_percent")
                        : t("pages.add_offer.select_flat"))
                      }                      
                      placeholder={
                        addoffer.type === "flat"
                          ? t("pages.add_offer.flatoffer_place")
                          : t("pages.add_offer.discountoffer_place")
                      }
                      value={addoffer?.percentage}
                      name={"percentage"}
                      type={"number"}
                      onChange={InputChange}
                      error={t(errors.percentage)}
                    />
                  </div>
                </div>
                <div className="mb-3 offers_div col-md-6 col-lg-6 col-xl-6 percentage-row ">
                  <div className="card" style={{ background: `${color}` }}>
                    <div className="offer_ticket">
                      <div class="offer_ticket_shape">
                        <div class="top"></div>
                        <div class="rip"></div>
                        <div
                          style={{
                            backgroundColor: `${LightenDarkenColor(
                              color,
                              -40
                            )}`,
                          }}
                          class="bottom"
                        ></div>
                      </div>
                      <div className="offer_ticket_content">
                        <div className="card-body">
                          <p className="font-12 mb-2">
                            {addoffer?.percentage === ""? (
                                <React.Fragment>
                                  {props?.language === "Tr"?(
                                    <React.Fragment>
                                      {`---${t("pages.add_offer.upto")} ${t( "pages.add_offer.off" )}`}
                                    </React.Fragment>
                                  ):(
                                    <React.Fragment>
                                      {`${t("pages.add_offer.upto")} --- ${t( "pages.add_offer.off" )}`}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )
                              :
                              addoffer?.type === "percentage"? (
                                <React.Fragment>
                                  {props?.language === "Tr"?(
                                    <React.Fragment>
                                      {`${ addoffer?.percentage }%${t("pages.add_offer.upto")} ${t("pages.add_offer.off")}`}
                                    </React.Fragment>
                                  ):(
                                    <React.Fragment>
                                      {`${t("pages.add_offer.upto")} ${ addoffer?.percentage }% ${t("pages.add_offer.off")}`}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              ):(
                                <React.Fragment>
                                  {props?.language === "Tr"?(
                                    <React.Fragment>
                                      {`${ addoffer?.percentage } ${process.env.REACT_APP_CURRENCY_SYMBOL}${t("pages.add_offer.upto")}  ${t( "pages.add_offer.off" )} `}
                                    </React.Fragment>
                                  ):(
                                    <React.Fragment>
                                      {`${t("pages.add_offer.upto")} ${ addoffer?.percentage } ${process.env.REACT_APP_CURRENCY_SYMBOL} ${t( "pages.add_offer.off" )} `}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                            )}
                          </p>
                          <h5 className="font-14 mb-1">
                            {addoffer?.title === ""
                              ? `-------`
                              : addoffer?.title}
                          </h5>
                          <p className="font-14 mb-1">
                            {props?.language === "Tr"?(
                              <React.Fragment>
                                {`${addoffer?.min_order_amount} ${process.env.REACT_APP_CURRENCY_SYMBOL}`} {t("pages.add_offer.above")}
                              </React.Fragment>
                            ):(
                              <React.Fragment>
                              {t("pages.add_offer.above")}{" "}
                              {`${addoffer?.min_order_amount} ${process.env.REACT_APP_CURRENCY_SYMBOL}`}
                              </React.Fragment>
                            )}
                          </p>
                          <p className="font-12 ">
                            {t("pages.add_offer.expire")}:{" "}
                            {addoffer?.end_date === ""
                              ? "----/--/--"
                              : moment(addoffer?.end_date).format('ddd, MMM DD YYYY')}
                          </p>
                        </div>
                        <div className="text-center coupon_code">
                          <p title="copy" className="mb-0" id="coupan">
                            {addoffer?.coupon_code}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3  col-md-6 col-lg-6 col-xl-6  voucher-row">
                <div className="mb-1 col-md-12 col-lg-12 col-xl-12 transition ">
                  <Form.Check
                    id={"voucherState"}
                    type={"checkbox"}
                    name={"voucherState"}
                    onChange={InputCheck}
                    defaultChecked={addoffer.voucherState}
                    checked={addoffer.voucherState}
                    label={t("pages.add_offer.vouchercode")}
                  />
                  <span className="warning text-danger">
                    {t(errors.voucherState)}
                  </span>
                </div>
                <div
                  className="col-12"
                  hidden={addoffer.voucherState ? false : true}
                >
                  <div className="d-flex align-center justify-content-between align-items-start">
                    <FormLabel 
                      label={t("pages.add_offer.code")}
                    />
                    <span
                      onClick={() =>
                        setAddoffer({
                          ...addoffer,
                          coupon_code: GenerateCode(14),
                        })
                      }
                      className="generte-code"
                    >
                      {t("pages.add_offer.generate")}
                    </span>
                  </div>
                  <FormControl
                    onChange={InputChange}
                    className={"text-upper transition"}
                    value={addoffer.coupon_code}
                    name={"coupon_code"}
                    id={"coupon_code"}
                    placeholder={t("pages.add_offer.code_place")}
                  />
                  <span className="warning text-danger">
                    {t(errors.coupon_code)}
                  </span>
                </div>
              </div>
              <div className="mb-3  col-md-6 col-lg-6 col-xl-6 min_order_amount-row">
                <FormgroupPage 
                  label={t("pages.add_offer.minimum")}
                  placeholder={t("pages.add_offer.minimum_warn")}
                  value={addoffer?.min_order_amount}
                  name={"min_order_amount"}
                  type={"number"}
                  onChange={InputChange}
                  error={t(errors.min_order_amount)}
                />
              </div>
              <Row className="ticket_top title_content_bottom">
                <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12 titledescri-row">
                  <Row>
                    <div className="mb-3  col-md-12 col-lg-6 col-xl-6 title-row">
                      <FormgroupPage 
                        label={
                          <React.Fragment>
                            {t("pages.add_offer.title_input")} {t("pages.In English")}
                          </React.Fragment>
                        }
                        placeholder={t("pages.add_offer.title_place")}
                        value={addoffer?.title}
                        name={"title"}
                        type={"text"}
                        onChange={InputChange}
                        error={t(errors.title)}
                      />
                    </div>
                    <div className="mb-3  col-md-12 col-lg-6 col-xl-6 title-row">
                      <FormgroupPage 
                        label={
                          <React.Fragment>
                             {t("pages.add_offer.title_input")} {t("pages.In Turkish")}
                          </React.Fragment>
                        }
                        placeholder={t("pages.add_offer.title_place")}
                        value={addoffer?.title_in_tr}
                        name={"title_in_tr"}
                        type={"text"}
                        onChange={InputChange}
                        error={t(errors.title_in_tr)}
                      />
                    </div>
                    <div className="mb-3  col-md-12 col-lg-6 col-xl-6 title-row">
                      <FormgroupPage 
                        label={
                          <React.Fragment>
                             {t("pages.add_offer.description")} {t("pages.In English")}
                          </React.Fragment>
                        }
                        placeholder={t("pages.add_offer.description_place")}
                        value={addoffer.description}
                        name={"description"}
                        type={"text"}
                        rows={4}
                        as={"textarea"}
                        onChange={InputChange}
                        error={t(errors.description)}
                      />
                    </div>
                    <div className="mb-3  col-md-12 col-lg-6 col-xl-6 title-row">
                      <FormgroupPage 
                        label={
                          <React.Fragment>
                            {t("pages.add_offer.description")} {t("pages.In Turkish")}
                          </React.Fragment>
                        }
                        placeholder={t("pages.add_offer.description_place")}
                        value={addoffer.description_in_tr}
                        name={"description_in_tr"}
                        type={"text"}
                        rows={4}
                        as={"textarea"}
                        onChange={InputChange}
                        error={t(errors.description_in_tr)}
                      />
                    </div>
                  </Row>
                </div>
                <div className="mb-3 col-sm-12 col-md-6 col-lg-6 col-xl-12 date-row">
                  <Row>
                    <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-3 ">
                      <div className=" ">
                        <FormLabel 
                          label={t("pages.add_offer.online_payment")}
                          require={false}
                        />
                        <div className="button-switch on-off-button me-3">
                          <input
                            type="checkbox"
                            name="for_online_payment"
                            onChange={InputCheck}
                            checked={addoffer.for_online_payment}
                            defaultChecked={addoffer.for_online_payment}
                            id="switch-blue"
                            className="switch"
                          />
                          <label htmlFor="switch-blue" className="lbl-off">
                            {t("pages.add_offer.off")}
                          </label>
                          <label htmlFor="switch-blue" className="lbl-on">
                            {t("pages.add_offer.on")}
                          </label>
                        </div>
                      </div>
                      <span className="warning text-danger">
                        {t(errors.for_online_payment)}
                      </span>
                    </div>
                    <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-3 ">
                      <FormLabel 
                        label={t("pages.add_offer.status")}
                        require={false}
                      />
                      <div className="button-switch ">
                        <input
                          type="checkbox"
                          name="active_status"
                          onChange={InputCheck}
                          checked={addoffer?.active_status}
                          defaultChecked={addoffer?.active_status}
                          id="active_status"
                          className="switch"
                        />
                        <label htmlFor="active_status" className="lbl-off">
                          {t("pages.add_offer.deactive")}
                        </label>
                        <label htmlFor="active_status" className="lbl-on">
                          {t("pages.add_offer.active")}
                        </label>
                      </div>
                      <span className="warning text-danger">
                        {t(errors.active_status)}
                      </span>
                    </div>
                    <div className="col-6 mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-3">
                      <FormLabel 
                        label={t("pages.add_offer.startdate")}
                      />
                      <ReactDatePicker minDate={new Date()} dateFormat={"dd-MM-yyyy"} selected={addoffer?.start_date ? new Date(addoffer?.start_date): null} showIcon onChange={(date)=>DateChange({value:date.toString(), name:"start_date"})} name="start_date" className="form-control" placeholderText={t('pages.dd-mm-yyyy')} />
                      <span className="warning text-danger">
                        {t(errors.start_date)}
                      </span>
                      {/* <FormgroupPage 
                        label={t("pages.add_offer.startdate")}
                        placeholder={""}
                        value={addoffer?.start_date}
                        name={"start_date"}
                        type={"date"}
                        onChange={DateChange}
                        error={t(errors.start_date)}
                      /> */}
                    </div>
                    <div className="col-6 mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-3">
                      <FormLabel 
                        label={t("pages.add_offer.enddate")}
                      />
                      <ReactDatePicker  minDate={new Date()} showIcon dateFormat={"dd-MM-yyyy"} selected={addoffer?.end_date ? new Date(addoffer?.end_date): null} onChange={(date)=>DateChange({value:date.toString(), name:"end_date"})} name="end_date" className="form-control" placeholderText={t('pages.dd-mm-yyyy')} />
                      <span className="warning text-danger">
                        {t(errors.end_date)}
                      </span>
                      {/* <FormgroupPage 
                        label= {t("pages.add_offer.enddate")}
                        placeholder={""}
                        value={addoffer?.end_date}
                        name={"end_date"}
                        type={"date"}
                        onChange={DateChange}
                        error={t(errors.end_date)}
                      /> */}
                    </div>
                  </Row>
                </div>
              </Row>
              {/* Hidden Content */}
              <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-right d-flex justify-content-end">
                <ButtonPage
                    className="button-cancel py-1 px-5 m-2 hover-btn"
                    Text={t("pages.cancel")}
                    type="button"
                    onClick={(e) => CancelForm(e)}
                />
                <ButtonPage
                    className="button-submit py-1 px-5 m-2 hover-btn"
                    Text={t("pages.save")}
                    type="submit"
                  />
              </div>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
  logindata: state?.login?.logindata,
  storeDetail: state?.dashboard?.storeDetail,
});

export default connect(mapStateToProps, { fetchHeaderContent,clearStoredetail,fetchLogindata })(AddofferPage);
